__turbopack_context__.v({
  "closeButton": "X10kwG_closeButton",
  "spacer": "X10kwG_spacer",
});
